const DocumentIcon = (props: any) => {
    return (
        <img {...props} alt="doc_icon.png" src={require('./document.png')} />
    );
};

export default DocumentIcon;
